import { Uuid } from '../../../../../../graphql';

export type FeedbackContext = {
    type: 'plan' | (typeof UserFeedbackType)[keyof typeof UserFeedbackType];
    id: Uuid;
    metadata?: PlanFeedbackMetadata;
};

type PlanFeedbackMetadata = {
    estimateId: Uuid;
};

export const UserFeedbackType = {
    AI_REVIEW: 'AIESTIMATEREVIEW',
    SMART_ESTIMATE: 'SMARTESTIMATEGENERATION',
} as const;
